






























import { Vue, Component, Prop } from 'vue-property-decorator'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import { Capacitor } from '@capacitor/core'

@Component({
  components: {
    [VueQrcode.name]: VueQrcode
  }
})
export default class QrCodeDialog extends Vue {
  loading = false

  @Prop({ default: false }) readonly opened!: boolean
  @Prop(String) readonly code!: string

  closeDialog() {
    this.$emit('update:opened', false)
  }

  get showPrint() {
    return !Capacitor.isNativePlatform()
  }

  print() {
    window.print()
  }
}
